module.exports = __webpack_public_path__ + "images/icons/icon-legal-2264c4f2.svg";